<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title v-if="deduction">
            {{ deduction.deduction_type.name }}
        </template>

        <template v-slot:header v-if="deduction">
            <!-- Tabs -->
            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'main'}" href="#tabDeductionContentMain" id="tabDeductionLinkMain" data-toggle="tab" role="tab" aria-controls="tabDeductionContentMain" :aria-selected="activeTab == 'main'">Main</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot>
            <div class="tab-content" v-if="deduction">
                <div class="tab-pane" :class="{'show active': activeTab == 'main'}" id="tabDeductionContentMain" role="tabpanel" aria-labelledby="tabDeductionLinkMain">
                    <!-- Positions widget -->
                    <info-widget :collapsible="false">
                        <template v-slot:title>Positions ({{ deduction.num_positions }})</template>

                        <template v-slot:headerbutton>
                            <button type="button" class="btn btn-outline-primary" @click.prevent="editPositions">
                                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                                Edit
                            </button>
                        </template>

                        <slot>
                            <div v-if="activePositions.length" class="p-1">
                                <table class="table css-table widget-table table-fixed">
                                    <thead>
                                        <tr>
                                            <th>Positions</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="position in activePositions" :key="position.id">
                                        <tr>
                                            <td class="truncate-wrapper">
                                                <span>{{ position.terminal_value }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="info-widget-empty p-2" v-else>
                                This deduction is not associated with any positions.
                            </div>
                        </slot>
                    </info-widget>
                </div>
            </div>
        </slot>

        <edit-deduction-positions-modal v-if="deduction" ref="editDeductionPositionsModal" :deduction="deduction" :client="client" @updated="onUpdate" @close="editPositionsModalOpen = false" />
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import EditDeductionPositionsModal from './EditDeductionPositionsModal'

export default {
    props: ['deductionId', 'client', 'tab', ],
    components: {Sidebar, InfoWidget, ButtonRow, EditDeductionPositionsModal},
    computed: {
        activePositions() {
            let ret = []
            if (this.deduction?.positions) {
                ret = this.deduction.positions.filter(p => p.is_active)
            }
            return ret
        }
    },
    data() {
        return {
            deduction: null,
            activeTab: this.tab || 'main',
            editPositionsModalOpen: false,
        }
    },
    watch: {
        deductionId() {
            this.getDeduction()
        }
    },
    mounted() {
        this.getDeduction()
    },
    methods: {
        getDeduction() {
            this.deduction = null
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/deduction-types/${this.deductionId}`).then(resp => {
                this.deduction = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        editPositions() {
            this.editPositionsModalOpen = true
            this.$refs.editDeductionPositionsModal.open()
        },
        onUpdate(deduction) {
            if (deduction) {
                Object.assign(this.deduction, deduction)
            }
            this.$emit('updated')
        }
    },
}
</script>

